<template>
    <div class="">
        <story-header
                :post="post.activity_post"
                :edit-mode="editMode"
                @onPostUpdate="onPostUpdate"
        ></story-header>
        <story-list
                :story-resource="storyResource"
                :target-id="post.id"
                :edit-mode="editMode"
        ></story-list>
    </div>
</template>

<script>
    import StoryList from "shared/story/StoryList";
    import StoryHeader from "shared/story/StoryHeader";
    import LikeStoryResourceFactory from "shared/story/resource_factory";
    import Vue from "vue";
    export default {
        name: "GroupPostDetailPageInfo",
        components: {StoryHeader, StoryList},
        props:{
            post: Object,
            editMode: Boolean,
        },
        computed:{
            storyResource(){
                const $http = Vue.getAngularModule('$http');
                return LikeStoryResourceFactory('group_activity_post_story')($http)
            }
        },
        methods:{
            onPostUpdate(postData) {
                this.$emit('onPostUpdate', postData);
            },
        }
    };
</script>